require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-peer-programming-5-reasons-learning-in-a-group-beats-studying-on-your-own.json") })
        }
      }, "path---blog-peer-programming-5-reasons-learning-in-a-group-beats-studying-on-your-own");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-peer-programming-5-reasons-learning-in-a-group-beats-studying-on-your-own!./.cache/json/blog-peer-programming-5-reasons-learning-in-a-group-beats-studying-on-your-own.json
// module id = 995
// module chunks = 231608221292675